import React from "react";
import classes from './MainHeader.module.scss'

interface MainHeaderProps {
    title?: string,
    BoxHeight?: string
}

    const MainHeader = ({BoxHeight = '85px', title }:MainHeaderProps) => {
        return (
            <div className={classes.background} style={{  height: BoxHeight }}>
                <p className={classes.title}>{title}</p>
            </div>
        )
    }

export  default MainHeader
